import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getTable } from '../../api/api';
import { formatDate } from '../../utils/helpers';

const NewsDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTable('tables/news', { limit: 200 });
        const all = res.data || [];
        const found = all.find((n) => n.slug === slug);

        if (!found) {
          navigate('/actualites');
          return;
        }

        setItem(found);
      } catch (e) {
        console.error('Erreur chargement actualité:', e);
        navigate('/actualites');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [slug, navigate]);

  if (loading) {
    return (
      <section className="section">
        <div className="container" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', padding: '60px' }}>Chargement...</div>
        </div>
      </section>
    );
  }

  if (!item) return null;

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Accueil</Link> / <Link to="/actualites">Actualités</Link> / {item.title}
          </div>
          <h1>{item.title}</h1>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{ maxWidth: '800px' }}>
          <img
            src={item.image_url}
            alt={item.title}
            style={{ borderRadius: '12px', marginBottom: '28px', boxShadow: 'var(--shadow-md)' }}
            loading="lazy"
          />
          <div className="card-meta" style={{ border: 'none', padding: 0, marginBottom: '24px' }}>
            <span>{item.author}</span>
            <span>{formatDate(item.publish_date)}</span>
          </div>
          <div style={{ fontSize: '1.05rem', color: '#212a33', lineHeight: '1.8' }}>
            {item.content ? item.content.split('\n').map((p, i) => (
              <p key={i}>{p}</p>
            )) : <p>Contenu non disponible.</p>}
          </div>
          <div style={{ marginTop: '40px' }}>
            <Link to="/actualites" className="btn btn-ghost">
              <i className="fa-solid fa-arrow-left"></i> Retour aux actualités
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsDetail;